module.exports = __webpack_public_path__ + "static/media/previous.a90e83d8.svg";